import { v4 as uuidv4 } from "uuid"
import { I18n } from "utils/i18n-shim"

export const FLEX_PURCHASE_PRODUCT_TYPE_ID = 5

export const formatPurchaseProductShort = (purchaseProduct) => {
  if (flexPurchaseProduct(purchaseProduct.purchase_type)) {
    return purchaseProduct.name
  }
  return `${purchaseProduct.name} (${purchaseProduct.runtime_in_days})`
}

export const purchaseTypes = [
  { id: 1, labelKey: "bulk" },
  { id: 2, labelKey: "withAE" },
  { id: 3, labelKey: "withoutAE" },
  { id: 4, labelKey: "fixed-price" },
  { id: 5, labelKey: "flex-product" }
]

export const getPurchaseTypeLabel = (purchaseType) =>
  I18n.t(`product.purchase-type.${purchaseType.labelKey}`)

export const flexPurchaseProduct = (type) =>
  type === FLEX_PURCHASE_PRODUCT_TYPE_ID

export const createIntegrationParameter = () => ({
  virtualId: uuidv4(),
  name: "",
  value: "",
  _destroy: false
})

/**
 * @param {JassApi.V2.PriceEditors.PurchaseProducts.PurchaseProduct} [purchaseProduct]
 */
export const getPriceChangeInitialValues = (purchaseProduct) => {
  return {
    new_purchase_price: purchaseProduct?.new_purchase_price ?? "",
    new_rrp: purchaseProduct?.new_rrp ?? "",
    new_stock_expires_at: purchaseProduct?.new_stock_expires_at ?? null,
    valid_from: purchaseProduct?.valid_from ?? null,
    activate: purchaseProduct?.activate ?? false,
    sales_products: purchaseProduct.sales_products.map((salesProduct) => {
      return {
        id: salesProduct.id,
        new_rrp: salesProduct.new_rrp ?? "",
        new_seller_lower_limit: salesProduct.new_seller_lower_limit ?? "",
        new_tl_price: salesProduct.new_tl_price ?? "",
        new_price_in_package: salesProduct.new_price_in_package ?? "",
        new_min_price_in_package: salesProduct.new_min_price_in_package ?? "",
        product_prices: salesProduct.product_prices.map((productPrice) => {
          return {
            id: productPrice.id,
            new_market_price: productPrice.new_market_price ?? "",
            new_price: productPrice.new_price ?? "",
            new_lower_limit: productPrice.new_lower_limit ?? ""
          }
        })
      }
    })
  }
}
